// src/pages/ShippingPolicyPage.jsx
// Standalone shipping policy page, linked from the footer ("Shipping
// Policy") next to Return Policy, and used as the shipping-policy URL
// Google Merchant Center asks for before it will list made-to-order items
// as "on display to order" on the Business Profile (free local listings).
// Same layout/styling as ReturnPolicyPage.jsx.
import React from "react";
import "./ContactPage.css";
import Footer from "../Footer";

const ShippingPolicyPage = () => {
  return (
    <div className="cp-root">
      <div className="cp-breadcrumb-bar">
        <div className="cp-breadcrumbs">
          <a href="/">Home</a>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">Shipping Policy</span>
        </div>
      </div>

      <section className="cp-rfq-section">
        <div className="cp-wrap" style={{ maxWidth: 860 }}>
          <span className="cp-badge">SHIPPING</span>
          <h1 style={{ margin: "16px 0 24px", fontSize: "2rem" }}>Shipping Policy</h1>

          <div style={{ fontSize: "1rem", lineHeight: 1.8, color: "#374151" }}>
            <p>
              Every order placed on bibaelectronics.com ships from our facility in
              Gurugram, Haryana (PIN 122004). This page explains where we ship, how long it
              takes, and what it costs.
            </p>

            <h3 style={{ marginTop: 28 }}>Where we ship</h3>
            <p>
              The online store ships to every serviceable PIN code in <strong>India</strong>.
              Enter your PIN code at checkout to confirm serviceability and see the exact
              delivery options for your address. For deliveries outside India, please
              request a quote through our <a href="/contact">Contact Us</a> page and we will
              arrange export shipping separately.
            </p>

            <h3 style={{ marginTop: 28 }}>Shipping charges</h3>
            <p>
              Shipping is calculated live at checkout from the courier's rate for your PIN
              code and the weight of your order. You'll see two options wherever both are
              available: <strong>Standard</strong> (the most economical courier) and{" "}
              <strong>Express</strong> (the fastest). A small handling fee on the shipping
              charge, plus GST, is shown as a separate line before you pay. There are no
              hidden charges after checkout.
            </p>

            <h3 style={{ marginTop: 28 }}>Dispatch and delivery times</h3>
            <p>
              <strong>In-stock items</strong> are handed to the courier within{" "}
              <strong>2 business days</strong> of payment confirmation. Delivery then
              typically takes 2 to 7 business days depending on your location and the
              option chosen; the estimate for your PIN code is shown at checkout.
            </p>
            <p>
              <strong>Made-to-order items</strong> are built or sourced against your order.
              Their lead time is stated on the product page (typically 4 to 8 weeks) and is
              counted from payment confirmation. We dispatch as soon as the item passes
              outgoing inspection and email you the tracking details.
            </p>
            <p>
              Business days are Monday to Saturday, excluding public holidays in Haryana.
            </p>

            <h3 style={{ marginTop: 28 }}>Orders with both in-stock and made-to-order items</h3>
            <p>
              At checkout you can choose to receive the whole order together once every
              item is ready, or to have the in-stock items shipped first as a separate
              parcel. Split shipping carries a small flat surcharge, shown before you pay,
              to cover the second consignment.
            </p>

            <h3 style={{ marginTop: 28 }}>Tracking</h3>
            <p>
              Once your parcel is collected you'll receive the courier name and tracking
              number by email, and the same details appear under <a href="/my-orders">My Orders</a> in your account.
            </p>

            <h3 style={{ marginTop: 28 }}>Packaging</h3>
            <p>
              Displays and touch panels are shipped in anti-static packaging inside
              cushioned cartons. Please inspect the parcel on delivery and note any visible
              damage with the courier before signing.
            </p>

            <h3 style={{ marginTop: 28 }}>Damaged, defective or missing items</h3>
            <p>
              If an item arrives damaged, defective or missing, report it within 7 days of
              delivery and we'll replace it at no cost, including return shipping. Full
              details are in our <a href="/about/return-policy">Return Policy</a>.
            </p>

            <h3 style={{ marginTop: 28 }}>Questions</h3>
            <p>
              Contact our team at{" "}
              <a href="mailto:info@bibaelectronics.com">info@bibaelectronics.com</a> or{" "}
              <a href="tel:+919561091506">+91 95610 91506</a> for anything about your
              shipment.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ShippingPolicyPage;
